import {
  LearnerDashboardCTAData,
  LearnerDashboardCTAVariant,
  UseLearnerDashboardCTA,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "learnerDashboardCta";

const useLearnerDashboardCTA: UseLearnerDashboardCTA = () => {
  const { isLoading, value } = useMonarchRule<{
    data: LearnerDashboardCTAData;
    variantCustomId: LearnerDashboardCTAVariant;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        showCta: false,
      },
    };
  }

  // Determine variant based on showCTA data
  const variant = value?.data?.showCta ? "show" : "hide";

  return {
    isLoading,
    variant,
    data: {
      showCta: value?.data?.showCta || false,
    },
  };
};

export default useLearnerDashboardCTA;
